import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05561de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-with-confirm-use" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, " COUPONの利用手続きは一度行うと元に戻せません。COUPONを使用済にしますか？ ", -1))
const _hoisted_3 = { class: "container-checkbox" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to-bottom-right" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "確認しました", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["checkbox", { checked: _ctx.checked }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('check')))
        }, _hoisted_6, 2),
        _hoisted_7
      ])
    ])
  ]))
}